import IndexingContractsEditor from './editor';

const IndexingContracts = {
  Editor: IndexingContractsEditor,
};

export default IndexingContracts;
